import { render, staticRenderFns } from "./procurementQuotationSettings.vue?vue&type=template&id=d1ba0004&scoped=true"
import script from "./procurementQuotationSettings.vue?vue&type=script&lang=js"
export * from "./procurementQuotationSettings.vue?vue&type=script&lang=js"
import style0 from "./procurementQuotationSettings.vue?vue&type=style&index=0&id=d1ba0004&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1ba0004",
  null
  
)

export default component.exports